var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-1",attrs:{"color":_vm.color,"text-color":_vm.textColor,"outlined":_vm.outlined,"small":""},on:{"click":_vm.cycle}},[_vm._v(" "+_vm._s(_vm.tag.name)+" "),(_vm.judgment !== 'correct')?_c('span',{staticClass:"ml-2 caption"},[_vm._v(_vm._s(_vm.shortLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }